import angular from 'angular';

angular
    .module('batch')

    .factory('BatchService', [
        '$resource',
        'API_CONFIG',
        function ($resource, API_CONFIG) {
            var Batch = $resource(
                API_CONFIG.url + '/v1/batch/:batchId',
                { batchId: '@Id' },
                {
                    // Recherche suivant les critères
                    searchByCriterias: {
                        url: API_CONFIG.url + '/v1/batch/searchByCriterias',
                        method: 'POST',
                        isArray: true,
                    },
                    // rebroadcast batch
                    rebroadcast: {
                        url: API_CONFIG.url + '/v1/batch/rebroadcast',
                        method: 'POST',
                    },
                    reject102: {
                        url: API_CONFIG.url + '/v1/batch/status-error',
                        method: 'POST',
                    },
                }
            );

            Batch.getDeliverable = function (batchId) {
                return API_CONFIG.url + '/v1/batch/' + batchId + '/deliverable?';
            };

            return Batch;
        },
    ]);
